/*
 * ap-mass.js — window.apMass, der JS-ZWILLING der Mass-Anzeige im Liquid (snippets/ap-mass-anzeige,
 * ap-felgenbreite, ap-spec-wert). Phase B, Pruefrunde 1 (minor, 29.09.2026): dieselbe Felge stand je
 * Block in anderer Schreibweise — Zubehoer „Reifen für 6,0J × 14″", direkt darunter Komplett „Reifen
 * für 6J × 14″", Fahrzeug-Detail „4×108", Fahrzeug-Zeile und Ergebnis roh „6x14 ET37" bzw.
 * „8,0x18 ET30" neben den Groessen-Chips „6 × 14 · ET 37". Jetzt rechnen Liquid und Skript dieselben
 * zwei Formen:
 *
 *   SATZ/TITEL   apMass.felge('6', '14')          -> '6,0J × 14″'   (Maulweite mit Nachkommastelle,
 *                                                                    wie ap-felgenbreite + „J")
 *   CHIP         apMass.chip('8x19 ET42 LK5/112') -> '8 × 19 · ET 42 · LK 5 × 112'
 *                apMass.chip(s, { lk: false })    -> '8 × 19 · ET 42'   (wie die Groessen-Chips der
 *                                                                    Kaufkarte, ap-mass-anzeige)
 *   LOCHKREIS    apMass.lk(4, ['108'])            -> '4 × 108'   (mehrere: '5 × 112/120')
 *   ZAHL         apMass.zahl('114.3')             -> '114,3'
 *
 * Eingabe der App (Proxy /passung, app/lib/vehicles/passung.server.ts masseText):
 * „<breite>x<zoll> ET<et> LK<lochzahl>/<lk>[/<lk2>]". Unbekanntes bleibt Byte fuer Byte stehen.
 * Trennzeichen: Option sep, sonst aus <html lang> (de -> ',', sonst '.'), wie ap.specsheet.decimal_sep.
 * Zwischen Zahl und × stehen geschuetzte Leerzeichen (kein Umbruch im Mass).
 *
 * Geladen `defer` von snippets/ap-fz-dialog (Fahrzeugwahl) und sections/wheel-tyre-link (Reifen fuer
 * diese Felge) vor deren Skripten; zweimal eingebunden laeuft es einmal. Proben: tests/mass-anzeige.test.js.
 */
(function () {
  'use strict';

  if (window.apMass) return;

  // Als Escape (Datei-Code nur ASCII): geschuetztes Leerzeichen, Malzeichen, Zollzeichen.
  var NB = '\u00a0';
  var MAL = '\u00d7';
  var ZOLL = '\u2033';

  function standardSep() {
    var l = String((document.documentElement && document.documentElement.getAttribute('lang')) || 'de').toLowerCase();
    return l.indexOf('de') === 0 ? ',' : '.';
  }

  function zahl(x, opt) {
    var sep = (opt && opt.sep) || standardSep();
    var s = String(x == null ? '' : x).trim();
    return /^-?\d+(\.\d+)?$/.test(s) ? s.replace('.', sep) : s;
  }

  /** Maulweite mit mindestens einer Nachkommastelle („6" -> „6,0", „11.75" -> „11,75"). */
  function breite(j, opt) {
    var s = String(j == null ? '' : j).trim();
    if (!s) return '';
    if (/^\d+$/.test(s)) s += '.0';
    return zahl(s, opt);
  }

  /** Satz/Titel: „6,0J × 14″" (ohne Maulweite nur „14″"). */
  function felge(j, d, opt) {
    var dz = String(d == null ? '' : d).trim();
    if (!dz) return '';
    var jz = String(j == null ? '' : j).trim();
    var zoll = zahl(dz, opt) + ZOLL;
    return jz ? breite(jz, opt) + 'J' + NB + MAL + NB + zoll : zoll;
  }

  /** Lochkreis „4 × 108" (Liste oder „112/120"). */
  function lk(n, pcd, opt) {
    var liste = Array.isArray(pcd) ? pcd : String(pcd == null ? '' : pcd).split('/');
    var teile = liste
      .map(function (x) {
        return zahl(x, opt);
      })
      .filter(Boolean);
    if (!teile.length) return '';
    var lz = String(n == null ? '' : n).trim();
    return lz ? lz + NB + MAL + NB + teile.join('/') : teile.join('/');
  }

  /** Chip-Form wie die Groessen-Chips: „8 × 19 · ET 42 · LK 5 × 112". */
  function chip(s, opt) {
    var roh = String(s == null ? '' : s);
    var mass = /(\d+(?:\.\d+)?)\s*[x\u00d7]\s*(\d+(?:\.\d+)?)/i.exec(roh);
    var et = /\bET\s*(-?\d+(?:\.\d+)?)/i.exec(roh);
    var lkm = /\bLK\s*(\d+)\s*[\/x\u00d7]\s*(\d+(?:\.\d+)?(?:\/\d+(?:\.\d+)?)*)/i.exec(roh);
    var teile = [];
    if (mass) teile.push(zahl(mass[1], opt) + NB + MAL + NB + zahl(mass[2], opt));
    if (et) teile.push('ET' + NB + zahl(et[1], opt));
    if (lkm && !(opt && opt.lk === false)) teile.push('LK' + NB + lk(lkm[1], lkm[2], opt));
    return teile.length ? teile.join(' \u00b7 ') : roh;
  }

  window.apMass = { zahl: zahl, breite: breite, felge: felge, lk: lk, chip: chip };
})();
